import SubscriptionStatusBanner from '../../view/components/Billing/SubscriptionStatusBanner';
import Sidebar from '../../view/components/Sidebar';
import { HeaderLayoutProvider } from '../context/HeaderLayoutContext';
import HeaderLayout from './HeaderLayout';

interface ISidebarLayoutProps {
  children: React.ReactNode;
}

export default function SidebarLayout({ children }: ISidebarLayoutProps) {
  return (
    <HeaderLayoutProvider>
      <div className="bg-surface-page flex h-dvh max-h-dvh overflow-hidden">
        <Sidebar />
        <div className="mt-15 flex min-w-0 flex-1 flex-col overflow-hidden md:mt-0">
          <HeaderLayout />
          <SubscriptionStatusBanner />
          <div className="flex min-h-0 flex-1 flex-col overflow-hidden p-2">
            {children}
          </div>
        </div>
      </div>
    </HeaderLayoutProvider>
  );
}
